import { KgInsightCategory } from '@api/api/kg-insights';
import { config } from '@terminal/config';
import { appPaths } from '@terminal/routes/app-paths';
import { queryKeys, queryValues } from '@terminal/routes/query-params';

/**
 * Category the `insight` mention chip's icon/color is keyed off of
 * (`insight-clipboard-marker.ts` in `@design/chat/mention-composer`). Scenario
 * insights aren't `KgInsight`s so they get their own `'scenario'` value.
 */
export type InsightShareCategory = 'scenario' | KgInsightCategory;

export const buildKgInsightShareUrl = (insightId: string) => {
  const search = new URLSearchParams({ insightId }).toString();

  return `${config.urls.webAppOrigin}${appPaths.kgInsight}?${search}`;
};

export const buildScenarioInsightShareUrl = (
  entityTag: string,
  insightId: string
) => {
  const search = new URLSearchParams({
    [queryKeys.activeDrawer]: queryValues.insightsDrawer,
    [queryKeys.entityTag]: entityTag,
    [queryKeys.activeInsight]: insightId,
  }).toString();

  // `appPaths.watchlist` redirects (dropping query params) when the account
  // has no watchlist selected yet, so land on the insight feed instead —
  // its `/focus` sub-route renders unconditionally and already reads
  // `activeDrawer` itself.
  return `${config.urls.webAppOrigin}${appPaths.insightFeed}/focus?${search}`;
};
